<template>
	<div class="page">
		<div class="">
			<div class="top">
				<div class="top_left">
					<div class="img1">
						<el-image :src="detail.ImagePcUrl" fit="fill"></el-image>
					</div>
					<div class="img2">
						<el-image :src="detail.CompanyLogo" fit="fill"></el-image>
					</div>
				</div>

				<div class="top_right">
					<div class="top_title">
						{{detail.ProductName}}
					</div>

					<div class="top_price">
						<div class="">
							保费金额
							<span class="">
								￥
							</span>
							<span class="">
								{{returnFloat(selPrice || detail.planList[0].Price)}}
							</span>
						</div>

						<div class="">
							原价：
							<s>￥{{returnFloat(costPrice || detail.planList[0].OriginalPrice)}}</s>
						</div>
					</div>

					<div class="top_sel">
						<div class="sel_list" v-for="(wrapItem,wrapIndex) in key" :key="wrapIndex">
							<div class="sel_title">
								{{wrapItem[0].name}}
							</div>
							<div class="type_list">
								<div @click="handleClick(item.state,wrapIndex,index)" class="type_item"
									:class="item.state" v-for="(item,index) in wrapItem" :key="index"
									v-if="!isMore || index < 4"
									:style="wrapItem.length  > 4 && !isMore ? 'margin-bottom:20px;' : ''">
									{{item.val}}
								</div>

								<div class="type_item" v-if="wrapIndex == 2 && isMore" @click="changeIsMore">
									更多选择
									<i class="el-icon-caret-bottom"></i>
								</div>
							</div>


						</div>
					</div>

					<div class="top_btn">
						<el-button type="primary" round @click="confirm" :disabled="btnType == 'buy-ban'">立即办理
						</el-button>
					</div>
				</div>

			</div>
			<div class="plan">
				<el-table
					:data="(isPlanContentLisr || planContentLisr.length<= 10) ? planContentLisr : planContentLisr2"
					stripe style="width: 100%" border fit>
					<el-table-column label-class-name="label_class" prop="itemName" :label="detail.ProductName"
						min-width="277px">
					</el-table-column>
					<!-- 					<el-table-column label-class-name="label_class" prop="Amount" label="保险理赔款" width="290px">
					</el-table-column> -->
					
					<template v-for="(item,index) in planContentLisr[0].secrityList" >
						<el-table-column label-class-name="label_class" :label="item.name" :key="index">
							<template slot-scope="scope">
								<span>{{scope.row.secrityList[index].price}}</span>
							</template>
						</el-table-column>
						
					</template>

				</el-table>
				<div class="plan_btn" v-if="!isPlanContentLisr && planContentLisr.length > 10">
					<el-button type="primary" plain @click="ChangePlanContentLisr">查看全部<i class="el-icon-arrow-down
"></i></el-button>
				</div>
			</div>

			<div class="notice">
				<div class="notice_tiele">
					投保须知
				</div>
				<div style="clear:both;"></div>

				<div :style="Notice ? 'height: auto;overflow: initial;' : ''" class="notice_main"
					v-html="detail.Notice">

				</div>

				<el-button v-if="!Notice" type="primary" plain @click="ChangeNotice" style="margin-top: 1.25rem;">查看全部<i
						class="el-icon-arrow-down
"></i></el-button>
			</div>

			<div class="compensate">
				<div class="compensate_tiele">
					理赔流程
				</div>
				<div style="clear:both;"></div>

				<div class="compensate_main" style="border-top: 1px solid #EEEEEE;">
					<div class="compensate_main_title">
						<div class="left">
							<div id="">
								<div id="">
								</div>
							</div>
						</div>

						<div class="compensate_main_index">
							01
						</div>

						<div class="compensate_main_tt">
							报案
						</div>
					</div>

					<el-image style="arrow"
						src="https://file.aavisa.com/browser-upload-file/ee61d745-5a57-4aaa-93d9-bc9d1420c0ce.jpg"
						fit="fill"></el-image>

					<div class="compensate_main_box1 ">
						<div class="main_box">
							<p>拨打4001-882-892报案</p>
							<p>保险事故发生后，建议您直接拨打保游网客服热
								线4001-882-892，保游网将全程助您处理相关
								理赔事宜；</p>
						</div>

					</div>
				</div>

				<div class="compensate_main">
					<div class="compensate_main_title">
						<div class="left">
							<div id="">
								<div id="">
								</div>
							</div>
						</div>

						<div class="compensate_main_index">
							02
						</div>

						<div class="compensate_main_tt">
							理赔资料
						</div>
					</div>

					<el-image style="arrow"
						src="https://file.aavisa.com/browser-upload-file/ee61d745-5a57-4aaa-93d9-bc9d1420c0ce.jpg"
						fit="fill"></el-image>

					<div class="compensate_main_box2 ">
						<div class="main_box">
							<p>准备理赔资料</p>
							<p>保游网将安排专业理赔客服人员告知您本次理赔
								所需要的各项材料井协助您收集整理，确保递交
								到保险公司的材料准确无误，节省您的宝责时间；</p>
						</div>

					</div>
				</div>

				<div class="compensate_main">
					<div class="compensate_main_title">
						<div class="left">
							<div id="">
								<div id="">
								</div>
							</div>
						</div>

						<div class="compensate_main_index">
							03
						</div>

						<div class="compensate_main_tt">
							申请理赔
						</div>
					</div>

					<el-image style="arrow"
						src="https://file.aavisa.com/browser-upload-file/ee61d745-5a57-4aaa-93d9-bc9d1420c0ce.jpg"
						fit="fill"></el-image>

					<div class="compensate_main_box3 ">
						<div class="main_box">
							<p>等待理赔审核</p>
							<p>待材料递交到保险公司后，保游网专业客服会按
								照保险公司所规定的时间跟进保险公司材料审进
								度，确保客户第一时间得知理赔进度；</p>
						</div>

					</div>
				</div>

				<div class="compensate_main">
					<div class="compensate_main_title">
						<div class="left">
							<div id="">
								<div id="">
								</div>
							</div>
						</div>

						<div class="compensate_main_index">
							04
						</div>

						<div class="compensate_main_tt">
							结案
						</div>
					</div>

					<el-image style="arrow"
						src="https://file.aavisa.com/browser-upload-file/ee61d745-5a57-4aaa-93d9-bc9d1420c0ce.jpg"
						fit="fill"></el-image>

					<div class="compensate_main_box4 ">
						<div class="main_box">
							<p>获得相应赔付</p>
							<p>结案后保游网专业客服会再次致电客户，告知赔
								付金额，打款时间，和收款账户信息；</p>
						</div>

					</div>
				</div>

			</div>
		</div>

		<div class="tips">
			<p>保险产品及运营：五洲（北京）保险经纪有限公司</p>
			<p>保险业务经营许可证:260446000000800</p>
		</div>

		<login ref="login"></login>
	</div>
</template>

<script>
	import login from '../../components/login/login.vue'
	export default {
		components: {
			login
		},
		data() {
			return {
				detail: null, // 产品
				active: 0,
				planList: [1, 1, 1, 1, 1, 1, 1],
				planContentLisr: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, ],
				planContentLisr2: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, ],
				isPlanContentLisr: false,

				isOpenPlanConten: false,
				isOpenNotice: false,
				isOpenPlanContenIndex: 4,
				show: false,
				animationDataSel: {}, //动态弹出框所需参数
				selHidden: true, //模态框是否隐藏
				btnType: "", //确定按钮禁用标记
				minusBan: "ban", //减号禁用标记
				plusBan: "ban", //加号禁用标记
				normalImg: "https://file.aavisa.com/OXPHOTO/20220725/1658729839479132.jpg", //商品初始化时显示的图片
				selImg: "https://file.aavisa.com/OXPHOTO/20220725/1658729839479132.jpg", //当前选择的商品图片
				selPrice: '', //当前选择的商品价格
				costPrice: '', //原价
				selTypeList: "-", //当前选择的商品类别详情
				selStock: "-", //当前选择的商品库存
				selNum: 1, //要购买的数量
				all_ids: [], //sku相关数据，用于后续操作
				key: [], //商品类型相关数据，一般通过调用服务端接口获取（这里可以自行修改数据，我写的数据比较简略）
				sku_list: [], ////商品详情数据，一般通过调用服务端接口获取
				sku_id: '',
				sku_id_Id: '',
				productId: '', //产品ID
				isMore: true,
				Notice: false,
			}
		},
		created() {
			console.log(this.$route.query)
			let {
				id
			} = this.$route.query;
			this.productId = id
			this.ProductDetail(id)
		},
		mounted() {

		},
		methods: {
			ChangePlanContentLisr() {
				this.isPlanContentLisr = true
			},

			confirm() {
				if (!this.$refs.login.checkLogin()) return false;
				//弹窗确认按钮触发
				if (this.btnType == "buy-ban") {
					return
				} else {
					let sku_id = this.sku_id;

					let {
						productId,
						sku_id_Id,
						selPrice,
						costPrice,
						isShop
					} = this
					this.$router.push(
						`/form?productId=${productId}&RateCode=${sku_id}&PlanRatePriceId=${sku_id_Id}&price=${selPrice}&tian=${this.all_ids[2]}`
					)
				}
			},

			changeIsMore() {
				this.isMore = false
			},

			// 获取小数点后两位
			returnFloat(value) {
				var value = Math.round(parseFloat(value) * 100) / 100;
				var xsd = value.toString().split(".");
				if (xsd.length == 1) {
					value = value.toString() + ".00";
					return value;
				} else if (xsd.length > 1) {
					if (xsd[1].length < 2) {
						value = value.toString() + "0";
					}
					return value;
				}
			},

			ProductDetail(id) {
				this.$api.ProductDetail({
					productId: id
				}).then(res => {
					console.log(res)
					let {
						data,
						status
					} = res.data;
					if (status == 200) {
						this.detail = data
						this.getSkuData()

					} else {
						this.detail = null
					}
				})
			},

			getSkuData() {
				let {
					detail
				} = this
				let key = [],
					aKey = [],
					bKey = [],
					cKey = [],
					sku_list = []
				for (let i = 0; i < detail.planList.length; i++) {
					var a = detail.planList[i].PlanName
					var aKey_ = {
						val: detail.planList[i].PlanName,
						name: '套餐选择',
						state: ''
					}
					aKey.push(aKey_)
					for (let x = 0; x < detail.planList[i].rateList.length; x++) {
						var b = a + '|' + detail.planList[i].rateList[x].AgeRange
						var bKey_ = {
							val: detail.planList[i].rateList[x].AgeRange,
							name: '承保年龄',
							state: ''
						}
						if (!bKey.length) {
							bKey.push(bKey_)
						} else {
							var _b_ = 1
							for (let e in bKey) {
								// console.log(bKey)
								if (bKey[e].val == detail.planList[i].rateList[x].AgeRange) {
									_b_ += 1
									break;
								}
							}

							if (_b_ == 1) {
								bKey.push(bKey_)
								_b_ = 1
							}
						}
						if (detail.planList[i].rateList[x].planRatePriceList.length > 0) {
							for (let y = 0; y < detail.planList[i].rateList[x].planRatePriceList.length; y++) {
								var c = b + '|' + detail.planList[i].rateList[x].planRatePriceList[y].DayRange
								var cKey_ = {
									val: detail.planList[i].rateList[x].planRatePriceList[y].DayRange,
									name: '保障期限',
									state: ''
								}

								if (!cKey.length) {
									cKey.push(cKey_)
								} else {
									var _r_ = 1
									for (let r = 0; r < cKey.length; r++) {
										if (cKey[r].val == detail.planList[i].rateList[x].planRatePriceList[y].DayRange) {
											_r_ += 1
											break;
										}
									}
									if (_r_ == 1) {
										cKey.push(cKey_)
										_r_ = 1
									}
								}
								var list = {
									'attrs': c,
									'num': 1,
									'price': this.returnFloat(detail.planList[i].rateList[x].planRatePriceList[y]
										.Price),
									'sku_id': detail.planList[i].rateList[x].planRatePriceList[y].RateCode,
									'costPrice': this.returnFloat(detail.planList[i].rateList[x].planRatePriceList[y]
										.OriginalPrice),
									'sku_id_Id': detail.planList[i].rateList[x].planRatePriceList[y].Id
								}
								sku_list.push(list)
							}
						} else {}

					}
				}
				key.push(aKey)
				key.push(bKey)

				for (let i = 0; i < cKey.length; i++) {
					for (let x = i + 1; x < cKey.length; x++) {
						if (cKey[i].val.split('-').length != 0) {
							// 范围
							if (Number(cKey[i].val.split('-')[0]) >
								Number(cKey[x].val.split('-')[0])) {
								var min = cKey[i]
								cKey[i] = cKey[x]
								cKey[x] = min
							}
						}
					}
				}

				key.push(cKey)
				let planList = detail.planList
				// let planContentLisr = detail.planList[this.active].secList
				// let planContentLisr2 = detail.planList[this.active].secList.slice(0, 10)
				let planContentLisr = detail.plansecrityList
				let planContentLisr2 = detail.plansecrityList.slice(0, 10)
				this.key = key
				this.sku_list = sku_list
				this.planList = planList
				this.planContentLisr = planContentLisr
				this.planContentLisr2 = planContentLisr2

				key.forEach((item, index) => {
					key[index][0].state = 'sel'
				})
				let select_ids = this.getSelAttrId(); //已选择的ids数组
				let all_ids = this.filterAttrs(select_ids); //已选择包含的所有节点，且有库存
				this.all_ids = all_ids

				let attrsVal = this.all_ids.join("|");
				for (let i = 0; i < this.sku_list.length; i++) {
					if (this.sku_list[i].attrs == attrsVal) {
						this.selStock = this.sku_list[i].num
						console.log(this.sku_list[i].sku_id)
						this.sku_id = this.sku_list[i].sku_id
						this.selPrice = this.sku_list[i].price
						this.costPrice = this.sku_list[i].costPrice
						this.sku_id_Id = this.sku_list[i].sku_id_Id
						break;
					}
				}
				this.update()
			},

			//获取所有包含指定节点的路线
			filterProduct(ids) {
				let result = [];
				this.sku_list.forEach(function(v, k) {
					let _attr = '|' + v['attrs'] + '|';
					let _all_ids_in = true;
					for (k in ids) {
						if (_attr.indexOf('|' + ids[k] + '|') == -1) {
							_all_ids_in = false;
							break;
						}
					}
					if (_all_ids_in) {
						result.push(v);
					}
				});
				return result;
			},
			//获取经过已选节点 所有线路上的全部节点
			// 根据已经选择得属性值，得到余下还能选择的属性值
			filterAttrs(ids) {
				var products = this.filterProduct(ids);
				var result = [];
				products.forEach(function(v, k) {
					result = result.concat(v['attrs'].split('|'));
				});
				return result;
			},
			//获取选中的id数组
			getSelAttrId() {
				let list = [];
				for (let i = 0; i < this.key.length; i++) {
					for (let j = 0; j < this.key[i].length; j++) {
						if (this.key[i][j].state == "sel") {
							list.push(this.key[i][j].val);
						}
					}
				}
				return list;
			},

			handleClick(state, trindex, tdindex) {
				//选择商品类型
				let that = this;

				// if (trindex == 0) {
				// 	this.planContentLisr = this.planList[tdindex].secList
				// 	this.planContentLisr2 = this.planList[tdindex].secList.slice(0, 10)
				// }

				if (state == "ban") { //被锁定
					return;
				} else if (state == "sel") { //被选择取反
					this.key[trindex][tdindex].state = "";
					if (trindex == 0) {
						let selImg = this.normalImg;
						this.selImg = selImg
					}
				} else if (state == "") { //选择
					//优化结果
					for (let i = 0; i < this.key[trindex].length; i++) {
						if (this.key[trindex][i].state == "sel") {
							this.key[trindex][i].state = "";
							break;
						}
					}
					this.key[trindex][tdindex].state = "sel";
					if (trindex == 0) {
						this.selImg = this.key[0][tdindex].images;
					}
				}
				this.key = this.key
				let select_ids = this.getSelAttrId(); //已选择的ids数组
				let all_ids = this.filterAttrs(select_ids); //已选择包含的所有节点，且有库存
				this.all_ids = all_ids
				this.set_block();
				this.update();
				this.selNum = 1
				let selLength = 0;
				for (let s = 0; s < that.key.length; s++) {
					for (let e = 0; e < that.key[s].length; e++) {
						if (that.key[s][e].state == "sel") {
							selLength++;
							break;
						}
					}
				}
				if (selLength == that.key.length) {
					this.btnType = ''
					this.selTypeList = that.all_ids.join("、")
					this.selStock = 1

					let attrsVal = that.all_ids.join("|");
					for (let i = 0; i < that.sku_list.length; i++) {
						if (that.sku_list[i].attrs == attrsVal) {
							that.selStock = that.sku_list[i].num
							that.sku_id = that.sku_list[i].sku_id
							that.selPrice = that.sku_list[i].price
							that.costPrice = that.sku_list[i].costPrice
							that.sku_id_Id = that.sku_list[i].sku_id_Id
							break;
						}
					}
					if (that.selNum > 1) {
						that.minuslBan = ''
					} else {
						that.minuslBan = "ban"
					}
					if (that.selNum >= that.selStock) {
						that.plusBan = "ban"
					} else {
						that.plusBan = ""
					}
				} else {
					that.btnType = "buy-ban"
					that.selTypeList = "-"
					that.selStock = "-"
					that.minusBan = "ban"
					that.plusBan = "ban"
				}
			},
			set_block() {
				//sku相关操作
				let list = [];
				let listTemp = [];
				for (let a = 0; a < this.key.length; a++) {
					listTemp.push(a);
				}
				for (let k = 0; k < this.key.length; k++) {
					for (let z = 0; z < this.key[k].length; z++) {
						if (this.key[k][z].state == "sel") {
							list.push(k)
							break;
						}
					}
				}
				let aSet = new Set(listTemp);
				let bSet = new Set(list);
				let differenceNew = Array.from(new Set(listTemp.concat(list).filter(v => aSet.has(v) && !bSet.has(v))))
				for (let i = 0; i < differenceNew.length; i++) {
					for (let j = 0; j < this.key[differenceNew[i]].length; j++) {
						if (this.key[differenceNew[i]][j].state != "sel") {
							if (this.all_ids.includes(this.key[differenceNew[i]][j].val)) {
								this.key[differenceNew[i]][j].state = "";
							} else {
								this.key[differenceNew[i]][j].state = "ban";
							}
						}
					}
				}
			},

			update() {
				//sku相关操作
				let that = this;
				let list = [];
				let select_ids = this.getSelAttrId();
				for (let i = 0; i < this.key.length; i++) {
					for (let j = 0; j < this.key[i].length; j++) {
						if (this.key[i][j].state == "sel") {
							list.push(i)
							break;
						}
					}
				}
				for (let a = select_ids.length - 1; a >= 0; a--) {
					let select_ids2 = this.del_array_val(select_ids, select_ids[a]);
					let all_ids = this.filterAttrs(select_ids2);
					that.key[list[a]].forEach((v1, k1) => {
						if (v1.state != "sel") {
							if (all_ids.includes(v1.val)) {
								that.key[list[a]][k1].state = "";
							} else {
								that.key[list[a]][k1].state = "ban";
							}
						}
					})
				}
			},
			del_array_val(arr, val) {
				//去除 数组 arr中的 val ，返回一个新数组
				var a = [];
				for (let k in arr) {
					if (arr[k] != val) {
						a.push(arr[k]);
					}
				}
				return a;
			},

			ChangeNotice() {
				this.Notice = true
			},
		}
	}
</script>

<style lang="less" scoped>
	.page {
		min-height: 100vh;

		.tips {
			font-size: 0.875rem;
			color: #999;
			min-height: 0px;
		}

		&>div {
			width: 75rem;
			margin: 1.25rem auto;
			min-height: 35rem;
		}

		.top {
			background-color: #ffffff;
			padding: 1.25rem;
			display: flex;
			justify-content: space-between;
			min-height: 25rem;

			.top_left {
				display: flex;
				flex-direction: column;
				align-items: flex-start;

				.img1 {
					.el-image {
						width: 25rem;
						height: 15rem;
					}
				}

				.img2 {
					margin-top: 1.25rem;

					.el-image {
						width: 9.5rem;
						height: 2.625rem;
					}
				}

			}

			.top_right {
				width: 46.125rem;

				.top_title {
					font-size: 1.75rem;
					color: #333333;
					text-align: left;
					margin-top: -0.5rem;
					font-weight: 600;
				}

				.top_price {
					padding: 1rem 1.25rem;
					background: linear-gradient(90deg, #ecf3fc, rgba(255, 255, 255, 0));
					display: flex;
					align-items: center;
					margin: 20px 0;

					&>div:nth-child(1) {
						font-size: 0.875rem;
						color: #666666;

						&>span:nth-child(1) {
							font-size: 1.125rem;
							color: #ff8033;
							margin-left: 1.25rem;
							vertical-align: middle;
						}

						&>span:nth-child(2) {
							font-size: 1.875rem;
							color: #ff8033;
							vertical-align: middle;
						}
					}

					&>div:nth-child(2) {
						font-size: 0.875rem;
						color: #999999;
						margin-left: 1.25rem;
					}
				}

				.top_sel {
					display: flex;
					flex-direction: column;
					align-items: flex-start;

					.sel_list {
						display: flex;
						margin-bottom: 1.25rem;

						.sel_title {
							display: flex;
							align-items: flex-start;
							white-space: nowrap;
							height: 2.6875rem;
							line-height: 2.6875rem;
						}

						.type_list {
							display: flex;
							align-items: center;
							margin-left: 0.78125rem;
							flex-wrap: wrap;

							.sel {
								border: solid 1px #599fff !important;
								color: #599fff !important;
							}

							.ban {
								background-color: #f5f5f5 !important;
								border: solid 1px #f5f5f5 !important;
							}

							.type_item {
								padding: 0.625rem 1.25rem;
								border: 1px solid #eee;
								border-radius: 3px;
								color: #666666;
								margin: 0 0.46875rem;
								cursor: pointer;
							}

						}
					}
				}

				.top_btn {
					text-align: left;

					/deep/ .el-button {
						padding: 0.75rem 1.625rem !important;
						font-size: 0.875rem !important;
						color: #fff !important;
						background-color: #599fff;
						border-color: #599fff;
					}
				}
			}
		}

		/deep/.label_class {
			font-size: 1.125rem;
			font-weight: 600;
			color: #000;
		}

		.plan {
			margin-top: 1.25rem;

			.plan_btn {
				width: 100%;
				height: 5.3125rem;
				background-color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.notice {
			padding: 1.25rem;
			background-color: #fff;
			margin-top: 1.25rem;

			.notice_main {
				height: 20.625rem;
				overflow: hidden;
				margin-top: 1.25rem;
				border-top: 1px solid #eeeeee;

				/deep/ p {
					text-align: left;
				}
			}

			.notice_tiele {
				font-size: 1.25rem;
				font-weight: 600;
				float: left;
				position: relative;
				display: inline-block;
				z-index: 10;
			}

			.notice_tiele:before {
				content: "";
				display: block;
				width: 100%;
				background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
				height: 0.375rem;
				position: absolute;
				bottom: 0;
				z-index: -1;
				border-radius: 12px;
			}
		}

		.compensate {
			margin-top: 1.25rem;
			padding: 1.25rem;
			background-color: #fff;

			.compensate_tiele {
				font-size: 1.25rem;
				font-weight: 600;
				float: left;
				position: relative;
				display: inline-block;
				z-index: 10;
			}

			.compensate_tiele:before {
				content: "";
				display: block;
				width: 100%;
				background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
				height: 0.375rem;
				position: absolute;
				bottom: 0;
				z-index: -1;
				border-radius: 12px;
			}


			.compensate_main {
				margin-top: 1.25rem;
				padding-top: 1.25rem;
				width: 100%;
				height: 14.375rem;
				position: relative;

				.compensate_main_title {
					width: 15.9375rem;
					height: 3.3125rem;
					display: flex;
					align-items: center;
					background: linear-gradient(90deg, #599fff, #90c4ff);
					border-radius: 30px;
					position: absolute;
					left: 0;
					top: 1.25rem;
					z-index: 100;

					.left {
						width: 2.5rem;
						height: 2.5rem;
						background-color: #fff;
						border-radius: 50%;
						margin-left: 0.525rem;
						display: flex;
						align-items: center;
						justify-content: center;

						&>div {
							width: 1.75rem;
							height: 1.75rem;
							background-color: #599fff;
							border-radius: 50%;
							display: flex;
							align-items: center;
							justify-content: center;

							&>div {
								width: 1.125rem;
								height: 1.125rem;
								background-color: #fff;
								border-radius: 50%;
							}
						}
					}

					.compensate_main_index {
						transform: skewX(-15deg);
						font-size: 1.75rem;
						color: #fff;
						margin-left: 1.25rem;
					}

					.compensate_main_tt {
						margin-left: 0.5rem;
						color: #fff;
						font-size: 1.25rem;
						vertical-align: middle;
						font-weight: 600;
					}
				}

				/deep/.el-image {
					position: absolute;
					left: 0.5rem;
					bottom: 0;
				}

				.main_box {
					text-align: left;
					line-height: 1rem;
					margin: 52px 0 0 60px;
					width: 43.75rem;
					font-size: 1rem;
					color: #333;
				}

				.compensate_main_box1 {
					width: 70.9375rem;
					height: 11.25rem;
					background: url('https://file.aavisa.com/browser-upload-file/49c2e44a-b239-4029-96f3-ca5a00cd0d9b.jpg') no-repeat 100% 100%;
					position: absolute;
					right: 0;
					bottom: 1.5625rem;
					z-index: 1;
				}

				.compensate_main_box2 {
					width: 70.9375rem;
					height: 11.25rem;
					background: url('https://file.aavisa.com/browser-upload-file/0a6bd31b-161f-4ebc-9509-eb3240f1a036.jpg') no-repeat 100% 100%;
					position: absolute;
					right: 0;
					bottom: 1.5625rem;
					z-index: 1;
				}

				.compensate_main_box3 {
					width: 70.9375rem;
					height: 11.25rem;
					background: url('https://file.aavisa.com/browser-upload-file/6956f796-90ae-4cd6-9d10-f63e877c98e4.jpg') no-repeat 100% 100%;
					position: absolute;
					right: 0;
					bottom: 1.5625rem;
					z-index: 1;
				}

				.compensate_main_box4 {
					width: 70.9375rem;
					height: 11.25rem;
					background: url('https://file.aavisa.com/browser-upload-file/fcfe351b-f496-4093-8e22-7b0f2a2e2290.jpg') no-repeat 100% 100%;
					position: absolute;
					right: 0;
					bottom: 1.5625rem;
					z-index: 1;
				}
			}




		}
	}
</style>



// WEBPACK FOOTER //
// src/page/Insurance/productDetile.vue